// extracted by mini-css-extract-plugin
export var createdDate = "_k7-1";
export var divider = "_k7-2";
export var headerDivider = "_k7-3";
export var messagesCard = "_k7-0";
export var messagesContainer = "_k7-6";
export var messagesContainerWrapper = "_k7-4";
export var showLeftPanelButton = "_k7-8";
export var topButtons = "_k7-7";
export var withPadding = "_k7-5";